<template>
  <div v-if="this.$route.name === 'IEInfo'">
        <!-- Header principal -->
    <div class="headerStyle">
      <div class="container page-container navbar pb-1" id="siteHeader">
        <img src="./assets/logo_LCL.gif" alt="Le Crédit Lyonnais" border="0" height="61px" />
        <img src="./assets/tit_app.gif" alt />
        <ul class="navbar-nav flex-row ml-md-auto d-none d-md-flex"
            style="margin-block-start: auto; margin-bottom: 4px;"
        />
      </div>
      <div class="container page-container main-container background-white mt-2 mb-2"
           style="padding-right: 0px; padding-left: 0px; box-shadow: -3px 5px 5px darkgrey; padding-bottom: 0px;">
        <router-view :to="{name: 'IEInfo'}">IEInfo</router-view>
      </div>
      <footer class="page-footer font-small blue footer-style" style="justify-content: center;" />
    </div>
  </div>
  <div v-else>
    <!-- Header principal -->
    <div class="headerStyle">
      <div class="container page-container navbar pb-1" id="siteHeader">
        <router-link :to="{ name: 'accueil'}">
          <img src="./assets/logo_LCL.gif" alt="Le Crédit Lyonnais" border="0" height="61px" />
        </router-link>
        <img src="./assets/tit_app.gif" alt />

        <!-- Menus de contact, metions legales etc dans le header -->
        <ul
          class="navbar-nav flex-row ml-md-auto d-none d-md-flex"
          style="margin-block-start: auto; margin-bottom: 4px;"
        >
          <li class="nav-item border-0 headerMenuLogo">
            <router-link v-if="$store.state.user.status.loggedIn" :to="{ name: 'accueil'}" class="headerMenuStyle">Se déconnecter</router-link>
            <router-link v-else :to="{ name: 'accueil'}" class="headerMenuStyle">Accueil</router-link>
          </li>

          <li class="nav-item border-0 headerMenuLogo">
            <router-link :to="{name: 'FAQ'}" class="headerMenuStyle">FAQ</router-link>
          </li>

          <li class="nav-item border-0 headerMenuLogo">
            <a
              class="headerMenuStyle"
              href="https://entreprises.lcl.fr/formulaire-Contact/?nom=Cartes-Affaires-Entreprises"
              target="_blank"
              rel="noopener"
              aria-label="Contact"
            >Contact</a>
          </li>

          <li class="nav-item border-0 headerMenuLogo">
            <router-link class="headerMenuStyle" :to="{name: 'mentionslegales'}">Mentions Légales</router-link>
          </li>
        </ul>
      </div>

      <!-- Menu sous le header -->
      <div id="sousMenuHeader"
        class="main-container navbar w-100 navbar-secondary py-0"
        style="justify-content: center;"
      >
        <li class="nav-item">
          <a
            target="_blank"
            rel="noopener"
            class="px-2"
            aria-label="Nos sites"
            href="https://www.lcl.fr/entreprise"
          >Nos sites</a>
        </li>
        <li class="nav-item">
          <a
            target="_blank"
            rel="noopener"
            class="px-2"
            aria-label="Nos implantations"
            href="https://www.lcl.fr/entreprise/agences-entreprise"
          >Nos implantations</a>
        </li>
        <li class="nav-item">
          <a
            target="_blank"
            rel="noopener"
            class="px-2"
            aria-label="LCLEntreprises"
            href="https://entreprises.secure.lcl.fr/"
          >LCLEntreprises</a>
        </li>
      </div>
    </div>

    <div
      class="container page-container main-container background-white mt-2 mb-2"
      style="padding-right: 0px; padding-left: 0px; box-shadow: -3px 5px 5px darkgrey; padding-bottom: 0px;"
    >
      <router-view :to="{name: 'accueil'}">Accueil</router-view>
    </div>

    <footer class="page-footer font-small blue footer-style" style="justify-content: center;">
      <!-- Copyright -->
      <div class="navbar w-100 py-0" style="justify-content: center;">
        <div class="nav-item">
          <router-link :to="{ name: 'accueil'}" class="px-2 footer-style">Accueil</router-link>
        </div>
        <div class="nav-item">
          <router-link class="px-2 footer-style" :to="{name: 'mentionslegales'}">Mentions Légales</router-link>
        </div>
        <div class="nav-item">
          <router-link class="px-2 footer-style" :to="{name: 'dataprotection'}">Politique des cookies et de protection des données</router-link>
        </div>
        <div class="nav-item">
          <a
            target="_blank"
            rel="noopener"
            class="px-2 footer-style"
            aria-label="Sécurité sur Internet"
            href="https://informations.lcl.fr/securite/"
          >Sécurité sur Internet</a>
        </div>
        <div class="nav-item">
          <a
            target="_blank"
            rel="noopener"
            class="px-2 footer-style"
            aria-label="Contact"
            href="https://entreprises.lcl.fr/formulaire-Contact/?nom=Cartes-Affaires-Entreprises"
          >Contact</a>
        </div>
        <div class="nav-item">
          <router-link :to="{name: 'FAQ'}" class="px-2 footer-style">FAQ</router-link>
        </div>
        <div class="nav-item">
          <a
            target="_blank"
            rel="noopener"
            class="px-2 footer-style"
            aria-label="Sites Internet"
            href="http://informations.lcl.fr/outils/annuaire.jsp"
          >Sites Internet</a>
        </div>
        <div class="nav-item">
          <a
            target="_blank"
            rel="noopener"
            class="px-2 footer-style"
            aria-label="Numéros utiles"
            href="https://entreprises.lcl.fr/numeros-utiles/"
          >Numéros utiles</a>
        </div>
      </div>

      <div align="right" style="margin-right: 10px">Version : {{version}}</div>
    </footer>
  </div>
</template>

<style lang="scss">
html,
body {
  -webkit-tap-highlight-color: transparent;
  text-rendering: optimizeLegibility;
  background-color: #cccccc !important;
}

.headerStyle {
  height: 80px;
  background-color: $blue-lcl;
  background: url(./assets/bg_top.gif) repeat-x;
}

//Style pour les boutons Accueil, contact... du header
.headerMenuStyle {
  float: right;
  font-family: verdana;
  margin-left: 15px;
  margin-right: 15px;
  height: 18px;
  color: white;
  font-size: 10px;
}

.headerMenuLogo {
  background: url(./assets/puce_tool.gif) no-repeat left bottom;
  padding-top: 38px;
}

.footer-style {
  font-size: 12px;
  color: #999999;
  font-weight: bold;
}

.navbar-secondary {
  font-size: 11px;
  background-image: linear-gradient(
    180deg,
    white 0%,
    #eeeeee 70%,
    #dddddd 100%
  );
  box-shadow: 0 0.5px 1px gray;
  li > a {
    color: $green-lcl;
    font-family: verdana, arial, helvetica, sans-serif;
    font-weight: bold;
  }
}

.background-white {
  background-color: white;
  border-bottom-left-radius: 150px;
}

.background-white-no-radius {
  background-color: white;
}

.navbar {
  border-bottom: 1px solid $shade-lighter;

  &.bg-white {
    background-color: $shade-lightest;
  }

  .logo {
    height: 25px;
  }

  .brand {
    font-size: 1rem;
    font-weight: $font-bold;
    text-transform: uppercase;
  }

  .navbar-toggler {
    border: 0;
    padding: 0.3rem 0.25rem 0.2rem;
    color: $shade-darkest;

    &:focus {
      outline: none;
    }
  }

  .nav-link {
    color: $shade-darkest !important;
    font-family: $font-title;
    font-weight: $font-bold;
    text-transform: uppercase;
    font-size: 0.9rem;

    &::before {
      content: ">";
    }
  }
}

.page-container {
  max-width: 980px !important;
}

.main-container {
  &.fixed-navbar {
    margin-top: 3.5rem;
  }

  .page {
    max-width: 900px;
  }

  .page-title {
    text-transform: uppercase;
    line-height: 1.2em;
    font-family: $font-title;
    font-size: $font-size-2;
    font-weight: $font-bold;
  }

  .btn-block {
    text-transform: uppercase;
    font-weight: $font-bold;
    font-size: 0.9rem;
    padding: 0.45rem 0.75rem;
  }

  .btn-goback {
    background-color: $shade-lighter;
    color: $text-primary;
  }
}

@media (min-width: 576px) {
  .navbar {
    .logo {
      height: 50px;
    }

    .brand {
      font-size: $font-size-2;
    }
  }

  .main-container.fixed-navbar {
    margin-top: 4.5rem;
  }
}

@media (min-width: 768px) {
  .navbar {
    border: none;
    padding: 1.5rem 1rem;

    .logo {
      height: 75px;
    }

    .brand {
      font-size: $font-size-1;
    }

    .nav-item {
      display: flex;
      align-items: center;
      font-weight: 500;
      border-right: 1px solid $shade-light;

      &:last-of-type {
        border-right: none;
      }

      .nav-link {
        padding: 0 15px;
        font-size: $font-size-4;
        font-weight: $font-bold;
        color: $shade-darkest;
        text-transform: uppercase;
        text-align: center;
        line-height: 1;
        max-width: 150px;

        &::before {
          content: "";
        }
      }
    }
  }

  .main-container.fixed-navbar {
    margin-top: 8rem;
  }

  div.ui-datepicker {
    font-size: 80%;
  }

  div.ui-datepicker-title {
    margin: 0!important;
    line-height: 2.5em!important;
    text-align: center;
    font-size: 16px;
  }
}
</style>

<script>
import $ from 'jquery'

// eslint-disable-next-line
jQuery(function ($) {
  $.datepicker.regional['fr'] = {
    closeText: 'Fermer',
    prevText: '&#x3c;Préc',
    nextText: 'Suiv&#x3e;',
    monthNames: ['Janvier', 'Fevrier', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Decembre'],
    monthNamesShort: ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Jun', 'Jul', 'Aou', 'Sep', 'Oct', 'Nov', 'Dec'],
    dayNames: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
    dayNamesShort: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
    dayNamesMin: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
    weekHeader: 'Sm',
    dateFormat: 'yy-mm-dd',
    firstDay: 1,
    isRTL: false,
    yearSuffix: ''
  }
  $.datepicker.setDefaults($.datepicker.regional['fr'])
})

export default {
  data () {
    return {
      version: require('../package.json').version
    }
  },
  mounted () {
    if (process.env.VUE_APP_DEV && process.env.VUE_APP_DEV === 'false') {
      $('#siteHeader').css({
        'padding-top': '8px'
      })
    }
  },
  computed: {
    isIdle () {
      return this.$store.state.idleVue.isIdle
    }
  },
  watch: {
    isIdle () {
      if (this.$store.state.idleVue.isIdle && this.$store.state.user.user) {
        this.$store.state.sessionTimeout = true
        this.$router.push('accueil')
      }
    }
  }
}
</script>
